module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBd.eot?v=6a0f8d5183f1789a899b1383f8d992dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBd.eot?
// module id = 681
// module chunks = 0